var exports = {
  "V": "xe533113f--c2aff6--close",
};

module.exports = exports;
